import $ from 'jquery';

class AgentLocations {
    constructor() {
    }

    init() {
        this.bindEvents();
        this.findToday();
        this.initMaps();
    }

    hideShowFullHours(e) {
        e.preventDefault();
        this.parentElement.querySelector('.full-office-hours').classList.toggle('show');
        this.parentElement.querySelector('.today-hours').classList.toggle('show');
        this.querySelector('.chevron').classList.toggle('down');
        let hoursCopy = this.querySelector('.hide-show-hours-copy');
        if (hoursCopy.classList.contains('copy-show')) {
            hoursCopy.innerHTML = 'Hide';
            hoursCopy.classList.toggle('copy-show');
        } else {
            hoursCopy.innerHTML = 'Show';
            hoursCopy.classList.toggle('copy-show');
        }
    }

    highlightToday(today) {
        let els = Array.from(document.getElementsByClassName('office-day-hours'));
        let todaysEls = els.filter(item => item.innerHTML.includes(today));
        todaysEls.forEach(day => day.classList.add('today'));
    }

    findToday() {
        let day;
        switch (new Date().getDay()) {
            case 0:
                day = 'Sunday';
                this.highlightToday(day);
                break;
            case 1:
                day = 'Monday';
                this.highlightToday(day);
                break;
            case 2:
                day = 'Tuesday';
                this.highlightToday(day);
                break;
            case 3:
                day = 'Wednesday';
                this.highlightToday(day);
                break;
            case 4:
                day = 'Thursday';
                this.highlightToday(day);
                break;
            case 5:
                day = 'Friday';
                this.highlightToday(day);
                break;
            case 6:
                day = 'Saturday';
                this.highlightToday(day);
                break;
            default:
                break;
        }
    }

    initMaps() {
        function fillMapData(map, id) {
            let mapTarget = `map-${id}`;
            let coords = { lat: map.Latitude, lng: map.Longitude };
            let currentMap = new google.maps.Map(document.getElementById(mapTarget), {
                center: coords,
                zoom: 17,
                disableDefaultUI: true,
                zoomControl: true
            });
    
            function setMapDirectionsHref(currentMap) {
                //let str = encodeURIComponent(`${currentMap.Address1} ${currentMap.Address2} ${currentMap.CityState} ${currentMap.Zipcode}`);
                let str = encodeURIComponent(`${currentMap.Latitude},${currentMap.Longitude}`); 
                let url = `https://www.google.com/maps/dir//${str}`;
                document.getElementById(mapTarget).parentElement.querySelector('a.get-directions').href = url;
                return url;
            }
            const contentString = 	`<div class='map-content-window'>
                                        <div class='copy'>
                                            ${map.Address1}<br/>
                                            ${map.CityState}  ${map.Zipcode}<br/>
                                            <a class='directions' target='_blank' href='${setMapDirectionsHref(map)}'>Get Directions</a><br/>
                                            <a class='phone' href='tel:${map.Phone}'>${map.Phone}</a>
                                        </div>
                                    </div>`;
            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });
            let marker = new google.maps.Marker({
                position: coords,
                currentMap,
                title: map.CityState,
                icon: '/content/images/custom/icon-location.png',
            });
            marker.addListener('click', () => {
                infowindow.open({
                anchor: marker,
                currentMap,
                shouldFocus: false,
                });
            });
            marker.setMap(currentMap);
        }
        window.Launchpad.Map.Locations.forEach((map, id) => fillMapData(map, id));
    }

    bindEvents() {
        let hoursButtons = Array.from(document.getElementsByClassName('show-full-hours'));
        hoursButtons.forEach(item => item.addEventListener('click', this.hideShowFullHours));
    }
}

export default AgentLocations;

$(() => {
	const agentLocations = new AgentLocations();
	agentLocations.init();
});